module.exports = __webpack_public_path__ + "img/ricelog_pinicon_052.6717e9fb.png";